import {getCookie, setCookie} from "@/static";

Array.prototype.pushIfNotExist = function ( item ) {
    if ( this.length === 0 )
        return this.push( item );
    for ( let i = 0; i < this.length; i ++ ) {
        if ( this[ i ] === item ) return;
        else if ( i === this.length - 1 ) {
            this.push( item );
        }
    }
};

Array.prototype.removeItemByKeyMatch = function ( keyType, value ) {
    const idx = this.findIndex( it => it[keyType] === value );
    this.splice(idx, 1);
};

Array.prototype.removeIdxIfExist = function ( item ) {
    for ( let i = 0; i < this.length; i ++ ) {
        if ( i === item ) {
            this.splice( i, 1 );
        }
    }
};

Array.prototype.removeItem = function ( value ) {
    const idx = this.findIndex( it => it === value );
    if ( idx > -1 ) {
        this.splice(idx, 1);
    }
};

Array.prototype.clear = function ( ) {
    while (this.length > 0) {
        this.pop();
    }
};

Array.prototype.sortByOrder = function( key, isDesc ) {
    const check = (a, b, desc = true) => {
        if (desc) {
            if (a > b)
                return -1
            else if (a < b)
                return 1
            else
                return 0;
        } else {
            if (a < b)
                return -1
            else if (a > b)
                return 1
            else
                return 0;
        }
    };

    this.sort(function (a, b) {
        return check(a[key], b[key], isDesc);
    });
};

Array.prototype.deepCopy = function (oriArr) {
    function copyArr(arr) {
        let copy = {};
        if (Array.isArray(arr)) {
            copy = arr.slice().map((value) => {
                return copyArr(value);
            });
        } else if (typeof arr === 'object' && arr !== null) {
            for (let attr in arr) {
                if (arr.hasOwnProperty(attr)) {
                    copy[attr] = copyArr(arr[attr]);
                }
            }
        } else {
            copy = arr;
        }
        return copy;
    }
    return new Promise( (resolve, reject) => {
        try {
            resolve( copyArr(oriArr) );
        } catch ( e ) {
            reject(`[Array.prototype.deepCopy] FAILED TO DEEP COPY ARRAY, it it really array?`, oriArr);
        }
    })
}

console.__proto__.dev = function() {
    if (process.env.NODE_ENV === "development") console.log('[h robotics]', ...arguments);
}

// Storage.prototype.setItem = function(key, value) {
//     setCookie(key, value, 'Session');
// }

// Storage.prototype.getItem = function(key) {
//     const value = getCookie(key);
//     return value === undefined || value === '' ? null : value;
// }